import StudentGoalsClient from '../shared/StudentGoalsClient';
import { URL } from '../../../constants/reading/ApiConstants';

class StudentGoalsClientReading extends StudentGoalsClient {
    static getStudentGoals = (studentIds, schoolYear) =>
        super.getStudentGoals(studentIds, schoolYear, URL.STUDENT_GOALS_URL);

    static saveStudentGoal = (
        { studentId, measure, goalValue, period, schoolYear, grade },
        staffId,
    ) =>
        super.saveStudentGoal(
            { studentId, measure, goalValue, period, schoolYear, grade },
            staffId,
            URL.STUDENT_GOALS_URL,
        );
}

export default StudentGoalsClientReading;
